import { Component, OnInit, ElementRef, ViewChild, NgZone } from '@angular/core';
import { SellerApiService } from '../service/seller-api.service';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { NewProjects, ProjectDetails, UpdateWorkerInformation, ReportTimeWork, Addworker, WorkerInformationObj,
  UpdateReportTimeWork } from '../seller';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as moment from 'moment';
import { environment } from '../../../environments/environment';
import { MapsAPILoader } from '@agm/core';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
// jQuery Sign $
declare let $: any;

@Component({
  selector: 'app-manage-projects',
  templateUrl: './manage-projects.component.html',
  styleUrls: ['./manage-projects.component.scss']
})
export class ManageProjectsComponent implements OnInit {
  userFirstname: string;
  buyerDisplayName: string;
  agreedProjects: Array<NewProjects> = [];
  workerlist: Array<any> = [];
  addworker: any = {};
  workerInformation: WorkerInformationObj  = new WorkerInformationObj();
  loaderActivate: boolean;
  // tslint:disable-next-line:no-inferrable-types
  isActiveIndex: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  isActiveWorkerIndex: number = 0;
  selectedindexEditTimer: number;
  subselectedindexEditTimer: number;
  value: Date;
  // tslint:disable-next-line:no-inferrable-types
  isManageProject: boolean = true;
  iseditable: boolean;
  public currentUserId: number = null;
  public currentSellerId: number = null;
  public projectId: number = null;
  // tslint:disable-next-line:no-inferrable-types
  public currentUserProfilePic: string = '';
  assignworker: any = {};
  assignproject: any = {};
  workerlistAll: Array<any> = [];
  assignworkersuccessmessage: string;
  reportworkersuccessmessage: string;
  @ViewChild('closeAddWorkerModal') closeAddWorkerModal: ElementRef;
  @ViewChild('reporttimeModalOpen') openReportTimeModal: ElementRef;
  @ViewChild('reporttimeModalOpenworker') openReportWorkerModal: ElementRef;
  @ViewChild('reporttimemodalClose') reporttimemodalClose: ElementRef;
  @ViewChild('addprojectclosebtn') addprojectclosebtn: ElementRef;
  @ViewChild('closeassignproject') closeassignproject: ElementRef;
  @ViewChild('closeassignworker') closeassignworker: ElementRef;
  @ViewChild('closeExcelDownload') closeExcelDownload: ElementRef;

  @ViewChild('addworkerform') addworkerform: NgForm;
  @ViewChild('assignprojectform') assignprojectform: NgForm;
  @ViewChild('assignworkerform') assignworkerform: NgForm;
  @ViewChild('reporttimeform') reportworkerform: NgForm;
  @ViewChild('addprojectform') addprojectform: NgForm;
  isanotheraddworker: boolean;

  workertypes: Array<any> = [];
  reporttimework: ReportTimeWork;
  timesheetsByprojectId: any = {};
  isSelectedWorkerReport: boolean;
  isedittimesheet: boolean;
  isSelectedTimesheetView: string;
  monthViewDatePicker: Date;
  weekViewDatePicker: Date;
  workerMonthViewDatePicker: Date;
  workerWeekViewDatePicker: Date;
  startDateMonth: string;
  endDateMonth: string;
  monthviewDisplayDate: string;
  weekviewDisplayDate: string;
  startDateWeek: string;
  endDateWeek: string;
  unAssignworkerlist: Array<any> = [];
  unAssignProjectlist: Array<any> = [];
  workeruserid: number;
  currentWorkerd: number;

  timesheetsByworkerId: any = {};
  workerMonthviewDisplayDate: string;
  workerWeekviewDisplayDate: string;
  startDateMonthWorker: string;
  endDateMonthWorker: string;
  startDateWeekWorker: string;
  endDateWeekWorker: string;
  isSelectedTimesheetWorkerView: string;

  serviceCategories: Array<any> = [];
  subserviceCategories: Array<any> = [];
  newprojects: any = {};
  newprojectsworker_id: Array<any> = [];
  projectssuggestionworker: Array<any> = [];
  // Report  Date:

  reportstartDate: string;
  reportendDate: string;
  reportselectedtype: number;
  reportStartDatePicker: Date;
  reportEndDatePicker: Date;
  isSelectedReportPeriod: string;
  reportDisplayViewDate: string;
  reporterrormessage: string;
  invalidValidationMsg: string = null;
  istimereport_enabled: boolean;
  @ViewChild('search')
  public searchElementRef: ElementRef;
  isAddreesInvalid: boolean;
  resendsuccessmessage: boolean;
  calendar_en: any;
  isaddnewproject: boolean;
  isActiveTabName = 'CustomerInfo';
  isActiveCutomerInfo: boolean;
  isActiveScope: boolean;
  isActiveDetails: boolean;
  constructor(private sellerService: SellerApiService,
    private cognitoService: CognitoUtil, public datepipe: DatePipe, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone) {
    // called first time before the ngOnInit()
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

  }

  ngOnInit() {

    this.calendar_en = {
      firstDayOfWeek: 1,
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
      dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
      dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
      monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni',
      'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
  };

    this.reporttimework = new ReportTimeWork();
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    this.userFirstname = localStorage.getItem('yasoUserFirstName');
    this.loaderActivate = true;
    this.addworker.worker_type = 'Worker';
    this.reporttimework.travel_type = 'Private';
    this.reporttimework.is_travel_cost_enabled = false;
    this.assignworker.is_location_required = false;
    this.assignproject.is_location_required = false;
    this.isSelectedTimesheetView = 'Month';
    this.isSelectedTimesheetWorkerView = 'Month';
    this.monthViewDatePicker = new Date();
    this.weekViewDatePicker = new Date();
    this.workerMonthViewDatePicker = new Date();
    this.workerWeekViewDatePicker = new Date();
    // Report
    this.reportStartDatePicker = new Date();
    this.reportEndDatePicker = new Date();
    this.reportselectedtype = 1;
    this.isSelectedReportPeriod = 'Month';
    this.reporterrormessage = '';


    // tslint:disable-next-line:prefer-const
    let findDate = this.getStartDateAndEndDate(this.monthViewDatePicker.getFullYear(), this.monthViewDatePicker.getMonth());
    this.startDateMonth = findDate.startDate;
    this.endDateMonth = findDate.endDate;
    this.setDisplayValueMonthAndWeek(this.monthViewDatePicker.getFullYear(), this.monthViewDatePicker.getMonth(), 'Project');
    // Week Implementaion
    // tslint:disable-next-line:prefer-const
    let findweekDate = this.getStartDateAndEndDateForWeek(this.weekViewDatePicker.toLocaleDateString());
    this.startDateWeek = findweekDate.startDate;
    this.endDateWeek = findweekDate.endDate;
    this.setDisplayValueForWeek('Project');

    // Worker Implementation --
    // tslint:disable-next-line:max-line-length
    // tslint:disable-next-line:prefer-const
    let findWorkerDate = this.getStartDateAndEndDate(this.workerMonthViewDatePicker.getFullYear(), this.workerMonthViewDatePicker.getMonth());
    this.startDateMonthWorker = findWorkerDate.startDate;
    this.endDateMonthWorker = findWorkerDate.endDate;
    this.setDisplayValueMonthAndWeek(this.workerMonthViewDatePicker.getFullYear(), this.workerMonthViewDatePicker.getMonth(), 'Worker');
    // Week Implementaion
    // tslint:disable-next-line:prefer-const
    let findworkerweekDate = this.getStartDateAndEndDateForWeek(this.workerWeekViewDatePicker.toLocaleDateString());
    this.startDateWeekWorker = findworkerweekDate.startDate;
    this.endDateWeekWorker = findworkerweekDate.endDate;
    this.setDisplayValueForWeek('Worker');

    //  Report Last month Details
    // tslint:disable-next-line:max-line-length
    // tslint:disable-next-line:prefer-const
    let findreportDate = this.getStartDateAndEndDate(this.reportEndDatePicker.getFullYear(), this.reportEndDatePicker.getMonth() - 1);
    this.reportstartDate = findreportDate.startDate;
    this.reportendDate = findreportDate.endDate;
    this.setDisplayValueMonthAndWeek(this.reportEndDatePicker.getFullYear(), this.reportEndDatePicker.getMonth(), 'Report');
    //  get current user id and  current user profile picture
    if (userDetails.username != null) {
      console.log("USER DETAILS");
      console.log(userDetails);
        this.sellerService.getProfileDetails(userDetails.username).subscribe(res => {
        if (res != null) {
          console.log("PROFILE DETAILS");
          console.log(res);
          this.currentUserId = res.user_id;
          this.currentSellerId = res.seller_id;
          this.currentUserProfilePic = res.image_url;  
          this.callWorkersListBysellerId(this.currentSellerId);
        }
      }, err => {
        console.log(err);
      });
    }

    // Call Agreed Projects
    console.log("LET'S GET SOME PROJECTS: " + userDetails.username);
    this.sellerService.getAllAgreedProjects(userDetails.username).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      console.log("Agreed projects");
      console.log(res);
      if (res != '-8') {
        this.agreedProjects = res;
        if (this.agreedProjects.length > 0) {
          if (this.agreedProjects[0].project_id && this.agreedProjects[0].project_id != null) {
            this.callProjectDetails(this.agreedProjects[0].project_id, 0);
          }
        }
      }
    }, err => {
      console.log(err);
    });

    // Call Worker Types List
    this.sellerService.getWorkerTypeDetails().finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.workertypes = res;
      }
    }, err => {
      console.log(err);
    });

    // Get the Service Category for Add New Project Page
    this.sellerService.getServiceCategories().subscribe(res => {
      console.log("CATEGORIES");
      console.log(res);
    if (res != null) {
        this.serviceCategories = res;
      }
    }, err => {
      console.log(err);
    });

    // Load Google Address
    this.loadAddressComponent();
  }


  // Set the Date for Month View and Week View StartDate and EndDate
  setDateForStartDateAndEndDate() {
    this.monthViewDatePicker = new Date();
    // GET THE FIRST AND LAST DATE OF THE MONTH.
    // tslint:disable-next-line:prefer-const
    let firstDay = new Date(this.monthViewDatePicker.getFullYear(), this.monthViewDatePicker.getMonth(), 1);
    // tslint:disable-next-line:prefer-const
    let lastDay = new Date(this.monthViewDatePicker.getFullYear(), this.monthViewDatePicker.getMonth() + 1, 0);

    // tslint:disable-next-line:prefer-const
    let mmfirst = (firstDay.getMonth() + 1 < 10) ? '0' + (firstDay.getMonth() + 1) : (firstDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddfirst = (firstDay.getDate() < 10) ? '0' + firstDay.getDate() : firstDay.getDate();

    // tslint:disable-next-line:prefer-const
    let mmlast = (lastDay.getMonth() + 1 < 10) ? '0' + (lastDay.getMonth() + 1) : (lastDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddlast = (lastDay.getDate() < 10) ? '0' + lastDay.getDate() : lastDay.getDate();

    // tslint:disable-next-line:max-line-length
    this.startDateMonth = firstDay.getFullYear() + '-' + mmfirst + '-' + ddfirst;
    this.endDateMonth = lastDay.getFullYear() + '-' + mmlast + '-' + ddlast;
  }


  // Tab On change Function Implementation
  tabOnChange(tab: string): void {
   // this.istimereport_enabled = false;
    if (tab === 'project') {
      this.isManageProject = true;
      this.isSelectedTimesheetView = 'Month';
      if (this.projectId != null) {
        this.timesheetsByprojectId.users_time_sheets_as_dict = [];
        this.getTimesheetsbyProjectId(this.projectId, this.startDateMonth, this.endDateMonth);
      }
    } else if (tab === 'worker') {
      this.isManageProject = false;
      this.isSelectedTimesheetWorkerView = 'Month';
      if (this.workeruserid != null) {
        this.timesheetsByworkerId.projects_time_sheets_as_dict = [];
        this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
        // this.getunAssignProjectListByworkerId(this.workeruserid);
      }
    } else if (tab === 'profileEdit') {
      this.iseditable = true;
    } else if (tab === 'save') {
      this.iseditable = false;
    }
  }


  // Call Project Details
  callProjectDetails(projectid: number, index: number): void {
    this.projectId = projectid;
    this.isActiveIndex = index;
    this.getAllWorkersList(this.projectId);
    this.getUnAssignWorkersList(this.projectId);
    // Call the Time Sheet accoring to the Selected view
    if (this.isSelectedTimesheetView === 'Month') {
      this.timesheetsByprojectId.users_time_sheets_as_dict = [];
      this.getTimesheetsbyProjectId(this.projectId, this.startDateMonth, this.endDateMonth);
    } else {
      this.timesheetsByprojectId.users_time_sheets_as_dict = [];
      this.getTimesheetsbyProjectId(this.projectId, this.startDateWeek, this.endDateWeek);
    }

  }


  // Call The View of Time Sheets
  callDisplayView(value: string): void {
    this.isSelectedTimesheetView = value;
    if (value === 'Month') {
      this.timesheetsByprojectId.users_time_sheets_as_dict = [];
      this.getTimesheetsbyProjectId(this.projectId, this.startDateMonth, this.endDateMonth);
    } else {
      this.timesheetsByprojectId.users_time_sheets_as_dict = [];
      this.getTimesheetsbyProjectId(this.projectId, this.startDateWeek, this.endDateWeek);
    }
  }

  // Call the View of Worker time sheets
  callWorkerViewTab(value: string): void {
    this.isSelectedTimesheetWorkerView = value;
    if (value === 'Month') {
      // this.timesheetsByworkerId.projects_time_sheets_as_dict = [];
      this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
    } else {
       this.timesheetsByworkerId.projects_time_sheets_as_dict = [];
      this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateWeekWorker, this.endDateWeekWorker);
    }
  }


  // Get Time sheets for Projects
  getTimesheetsbyProjectId(project_id: number, startdate: string, enddate: string): void {
    if (project_id === null) {
      return;
    }
    this.loaderActivate = true;
    // Call workers by Projects
    this.sellerService.getshowtimesheetsByProject(project_id, startdate, enddate).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.timesheetsByprojectId = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // Get Time sheets for Workers
  getTimesheetsbyCurrentUserId(userid: number, startdate: string, enddate: string): void {
    if (userid === null) {
      return;
    }
    this.loaderActivate = true;
    // Call workers by Projects
    this.sellerService.getshowtimesheetsByUserId(userid, startdate, enddate).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.timesheetsByworkerId = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // Clear form Initially
  clearAddWorkerForm() {
    this.addworkerform.resetForm();
    this.addworker = {};
    this.addworkerform.form.get('worker_type_id').setValue(undefined);
    this.invalidValidationMsg = null;
  }

  // Identify the Button
  callbtnIdentify(isidentify: boolean) {
    this.isanotheraddworker = isidentify;
  }

  // Checking Email Exists or Not
  checkemailValidation(event: any) {
    this.invalidValidationMsg = null;
    // without type info
    if (event.target.value !== undefined && event.target.value !== null && event.target.value !== '') {
      this.addworker.worker_email = event.target.value;
      this.sellerService.checkUserNameExitsOrNot(this.addworker.worker_email).subscribe(res => {
        if (res) {
          this.invalidValidationMsg = 'Already Exits the email';
        }
      }, err => {
        console.log(err);
        // this.invalidValidationMsg = 'Already Exits the email';
      });
    }
  }

  // Call Submit for Add Worker
  calladdworker(model: any, isValid: boolean): void {
    if (!isValid) {
      return;
    }
    if (this.invalidValidationMsg !== null) {
      return;
    }

    if (this.addworker.worker_type_id === null || this.addworker.worker_type_id === undefined) {
      return;
    }
    this.loaderActivate = true;
    // Call workers by Projects
    this.addworker.seller_id = this.currentSellerId;
    console.log("SELLER ID: " + this.currentSellerId);
    // this.addworker.project_id = this.projectId;
    this.invalidValidationMsg = null;
    this.sellerService.addworkerstoProject(this.addworker).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      console.log("RESULTS");
      console.log(res);
      if (res === 200) {
        if (!this.isanotheraddworker) {
          this.closeAddWorkerModal.nativeElement.click();
        }
        this.callWorkersListBysellerId(this.currentSellerId);
        if (this.projectId != null) {
          this.getUnAssignWorkersList(this.projectId);
        }
        this.clearAddWorkerForm();
      } else if (res === -8) {

      } else if (res === -2) {
        this.invalidValidationMsg = 'Already Exits the email';
      }
    }, err => {
      console.log(err);
    });
  }

  hasWhiteSpace(s) {
    // tslint:disable-next-line:prefer-const
    let reWhiteSpace = new RegExp(/^\s+$/);
    // Check for white space
    if (reWhiteSpace.test(s)) {
      return false;
    }
    return true;
  }

  // Re- send Invitation to Buyer
  resendInvitationworker() {
    this.loaderActivate = true;
    this.sellerService.resendinvitationto_worker(this.workerInformation.worker_email).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      this.resendsuccessmessage = true;
      setInterval(() => {
        this.resendsuccessmessage = false;
      }, 7000);
    }, err => {
      console.log(err);
    });
  }

  // Update Worker Information
  updateWorkerInformation(): void {
    if (!this.hasWhiteSpace(this.workerInformation.worker_name) || this.workerInformation.worker_name === '') {
      return;
    }

    // tslint:disable-next-line:prefer-const
    let editworker = new UpdateWorkerInformation();
    editworker.worker_id = this.workerInformation.worker_id;
    editworker.worker_name = this.workerInformation.worker_name;
    editworker.worker_type_id = this.workerInformation.worker_type_id;
    editworker.hourly_rate = this.workerInformation.hourly_rate;
    editworker.phone_no = this.workerInformation.worker_phone_no;
    editworker.designation = this.workerInformation.worker_designation;
    editworker.contact_person_name = this.workerInformation.contact_person_name;
    editworker.contact_person_phone_no = this.workerInformation.contact_person_phone_no;
    this.loaderActivate = true;
    this.sellerService.updateworkerstoProject(editworker).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      this.iseditable = false;
      this.callWorkerListWithOutLoading(this.currentSellerId);
      this.getAllWorkersList(this.projectId);

    }, err => {
      console.log(err);
    });
  }

  // Call Worker List Update
  callWorkerListWithOutLoading(sellerId: number): void {
    this.sellerService.getShowWorkersBySellerId(sellerId).subscribe(res => {
      if (res != null) {
        this.workerlistAll = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // Call the Workers List
  callWorkersListBysellerId(sellerId: number): void {
    // this.loaderActivate = true;
    // Call workers by Projects
    this.sellerService.getShowWorkersBySellerId(sellerId).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.workerlistAll = res;
        if (this.workerlistAll.length > 0) {
          this.callworkerInformation(this.workerlistAll[0].worker_id, 0, this.workerlistAll[0].user_id);
        }
      }
    }, err => {
      console.log(err);
    });
  }


  // Get the Worker's List from the Projects
  getAllWorkersList(projectid: number): void {
    this.loaderActivate = true;
    // Call workers by Projects
    this.sellerService.getWorkersByprojectId(projectid).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.workerlist = res;
      }
    }, err => {
      console.log(err);
    });
  }


  // Get the Un Assign Worker's List from the Projects
  getUnAssignWorkersList(projectid: number): void {
    if (projectid === null) {
      return;
    }
    // Call workers by Projects
    this.sellerService.getUnAssignWorkersByprojectId(projectid).subscribe(res => {
      if (res != null) {
        this.unAssignworkerlist = this.filterActiveWorkers(res);
      }
    }, err => {
      console.log(err);
    });
  }

  // Get the Projects By worker Id.. un assign
  getunAssignProjectListByworkerId(workerid: number): void {
    if (workerid === null) {
      return;
    }
    // Call projects by workers
    this.sellerService.getUnAssignProjectsByWorkerId(workerid).subscribe(res => {
      if (res != null) {
        this.unAssignProjectlist = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // Active Worker Filter
  filterActiveWorkers(response: Array<any>) {
    return response.filter(item => item.worker_status_code === 0);
  }

  // Call worker Information
  callworkerInformation(workerid: number, index: number, user_id: number): void {
    this.isActiveWorkerIndex = index;
    this.workeruserid = user_id;
    this.currentWorkerd = workerid;
    if (this.isSelectedTimesheetWorkerView === 'Month') {
      this.timesheetsByworkerId.projects_time_sheets_as_dict = [];
      this.getTimesheetsbyCurrentUserId(user_id, this.startDateMonthWorker, this.endDateMonthWorker);
    } else {
      this.timesheetsByworkerId.projects_time_sheets_as_dict = [];
      this.getTimesheetsbyCurrentUserId(user_id, this.startDateWeekWorker, this.endDateWeekWorker);
    }
    this.getunAssignProjectListByworkerId(workerid);
    this.loaderActivate = true;
    // Call workers by Projects
    this.sellerService.getWorkerInformation(workerid).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.workerInformation = res;
        this.istimereport_enabled = res.is_time_reporting_enabled;
      }
    }, err => {
      console.log(err);
    });
  }


  resetModalForm(): void {
    this.closeAddWorkerModal.nativeElement.click();
  }
  // Clear Assign worker Form
  callClearAssignWorkerForm(): void {
    this.assignworkerform.resetForm();
    this.assignworkerform.form.get('worker_id').setValue(undefined);
    this.assignworkerform.form.get('is_location_required').setValue(false);
    this.assignworkersuccessmessage = '';
  }

  // Call Assign worker Post Method
  callAssignWorker(model: any, isValid: boolean): void {
    this.assignworkersuccessmessage = '';
    if (!isValid) {
      return;
    }
    this.assignworker.project_id = this.projectId;
    if (this.assignworker.project_id === null || this.assignworker.project_id === undefined) {
      return;
    }
    if (this.assignworker.worker_id === null || this.assignworker.worker_id === undefined) {
      return;
    }

    this.loaderActivate = true;
    this.sellerService.assignWorkertoProject(this.assignworker).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        if (!this.isanotheraddworker) {
          this.closeassignworker.nativeElement.click();
        }
        this.assignworkersuccessmessage = 'Successfully Added Worker';
        this.assignworker.is_location_required = false;
        this.getUnAssignWorkersList(this.projectId);
        this.assignworkersuccessmessage = '';
        this.callClearAssignWorkerForm();
        if (this.isSelectedTimesheetView === 'Month') {
          // this.timesheetsByprojectId.users_time_sheets_as_dict = [];
          this.getTimesheetsbyProjectId(this.projectId, this.startDateMonth, this.endDateMonth);
        } else {
          // this.timesheetsByprojectId.users_time_sheets_as_dict = [];
          this.getTimesheetsbyProjectId(this.projectId, this.startDateWeek, this.endDateWeek);
        }

      }
    }, err => {
      console.log(err);
    });
  }



  // Clear Assign worker Form
  callClearAssignProjectForm(): void {
    this.assignprojectform.resetForm();
    this.assignprojectform.form.get('project_id').setValue(undefined);
    this.assignprojectform.form.get('is_location_required').setValue(false);
  }

  // Call Assign Project Post Method
  callAssignProject(model: any, isValid: boolean): void {
    if (!isValid) {
      return;
    }
    this.assignproject.worker_id = this.currentWorkerd;
    if (this.assignproject.worker_id === null || this.assignproject.worker_id === undefined) {
      return;
    }
    if (this.assignproject.project_id === null || this.assignproject.project_id === undefined) {
      return;
    }

    this.loaderActivate = true;
    this.sellerService.assignWorkertoProject(this.assignproject).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        if (!this.isanotheraddworker) {
          this.closeassignproject.nativeElement.click();
        }
        this.assignproject.is_location_required = false;
        this.getunAssignProjectListByworkerId(this.currentWorkerd);
        // Call the Timesheets for every person
        if (this.isSelectedTimesheetWorkerView === 'Month') {
          // this.timesheetsByworkerId.projects_time_sheets_as_dict = [];
          this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
        } else {
          // this.timesheetsByworkerId.projects_time_sheets_as_dict = [];
          this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateWeekWorker, this.endDateWeekWorker);
        }
      }
      this.callClearAssignProjectForm();
    }, err => {
      console.log(err);
    });

  }

  // Location change Accoring to the click
  changeLocationRequired(isTrue: boolean, index: number, workeruserid: number) {
    // tslint:disable-next-line:prefer-const
    let anymodal = {
      worker_user_id: workeruserid,
      project_id: this.projectId,
      is_location_required: isTrue
    };
    this.loaderActivate = true;
    this.sellerService.change_is_location_required(anymodal).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res === 200) {
        console.log('successfully changed');
      }
    }, err => {
      console.log(err);
    });
  }

  // changeLocationRequired =- worker
  changeLocationRequired_worker(isTrue: boolean, index: number, projectid: number) {
    // tslint:disable-next-line:prefer-const
    let anymodal = {
      worker_user_id: this.workeruserid,
      project_id: projectid,
      is_location_required: isTrue
    };
    this.loaderActivate = true;
    this.sellerService.change_is_location_required(anymodal).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res === 200) {
        console.log('successfully changed');
      }
    }, err => {
      console.log(err);
    });
  }

  // call reset Assign worker
  callResetAssignWorker(): void {
    this.assignworker = {};
    // this.addworkerform.reset();
    // yourForm.reset(), yourForm.resetForm() don't work, but this does:
    this.addworkerform.form.markAsPristine();
    this.addworkerform.form.markAsUntouched();
    this.addworkerform.form.updateValueAndValidity();

  }

  clearReportTimeModal(): void {
    this.reportworkersuccessmessage = '';
    this.isSelectedWorkerReport = false;
    this.istimereport_enabled = true;
    if (!this.isedittimesheet) {
      this.reportworkerform.resetForm();
      this.reporttimework = new ReportTimeWork();
      this.reportworkerform.form.get('user_id').setValue(undefined);
      this.reporttimework.travel_type = 'Private';
      this.reportworkerform.form.get('is_travel_cost_enabled').setValue(false);
      this.reportworkerform.form.get('date').setValue(new Date());
      this.reporttimework.reason = '';
    }

    this.isedittimesheet = false;
  }

  // Report Time Call Post Method
  callReportTime(model: any, isValid: boolean): void {
    this.reportworkersuccessmessage = '';
    if (!isValid) {
      return;
    }
    // tslint:disable-next-line:prefer-const
    if (!this.Check_arrival(model.hours)) {
      return;
    }

    if (this.isManageProject) {
      this.reporttimework.project_id = this.projectId;

    } else {
      this.reporttimework.project_id = this.subselectedindexEditTimer;
    }

    if (this.reporttimework.project_id === null || this.reporttimework.project_id === undefined) {
      return;
    }

    this.reporttimework.date = this.datepipe.transform(this.reporttimework.date, 'yyyy-MM-dd hh:mm:ss');
    this.loaderActivate = true;
    // tslint:disable-next-line:prefer-const
    let backObj: UpdateReportTimeWork = new UpdateReportTimeWork();
    // backObj = this.reporttimework;
    backObj.hours = this.reporttimework.hours + ':00';
    backObj.project_id = this.reporttimework.project_id;
    backObj.user_id = this.reporttimework.user_id;
    backObj.date = this.reporttimework.date;
    backObj.is_travel_cost_enabled = this.reporttimework.is_travel_cost_enabled;
    backObj.comment = (this.reporttimework.comment === undefined) ? '' : this.reporttimework.comment;
    backObj.reason = (this.reporttimework.reason === undefined) ? '' : this.reporttimework.reason;
    backObj.travel_distance = (this.reporttimework.travel_distance === undefined) ? 0 : Number(this.reporttimework.travel_distance);
    (this.reporttimework.travel_type === 'Private') ? backObj.travel_type = 0 : backObj.travel_type = 1;
    this.sellerService.reporttimeByProjectId(backObj).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.reportworkersuccessmessage = 'Successfully added';
        this.reporttimemodalClose.nativeElement.click();
        if (this.isManageProject) {
          if (this.isSelectedTimesheetView === 'Month') {
            this.getTimesheetsbyProjectId(this.projectId, this.startDateMonth, this.endDateMonth);
          } else {
            this.getTimesheetsbyProjectId(this.projectId, this.startDateWeek, this.endDateWeek);
          }

        } else {
          if (this.isSelectedTimesheetWorkerView === 'Month') {
            this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
          } else {
            this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateWeekWorker, this.endDateWeekWorker);
          }
        }
        this.isedittimesheet = false;
        this.isSelectedWorkerReport = false;
      }
    }, err => {
      console.log(err);
    });
  }

  Check_arrival(time) {
    // Assuming you are working in 12 hour time, 0 is not a valid
    // tslint:disable-next-line:prefer-const
    let patt = new RegExp('^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');
    // tslint:disable-next-line:prefer-const
    let res = patt.test(time);
    return res;
  }

  // Onchange Time Reporting Worker
  onChangeSelectedWorker(userid, selectedItem) {
    this.workerlist.map((item) => {
      if (item.user_id === Number(userid)) {
        this.istimereport_enabled = item.is_time_reporting_enabled;
      }
    });
  }

  // Update Time Sheet
  updatetimeSheet(item: any, index: number, subi: number, is_enable_timereport: boolean): void {
    this.reportworkersuccessmessage = '';
    this.isedittimesheet = true;
    if (this.isManageProject) {
      this.openReportTimeModal.nativeElement.click();
    } else {
      this.openReportWorkerModal.nativeElement.click();
      this.subselectedindexEditTimer = subi;
    }
    if (item.user_id === this.currentUserId) {
      this.isSelectedWorkerReport = true;
    }

    this.reporttimework = new ReportTimeWork();
    // tslint:disable-next-line:max-line-length
    (item.travel_type === 0 || item.travel_type === undefined) ?  this.reporttimework.travel_type = 'Private' :  this.reporttimework.travel_type = 'Corporate' ;
    (item.is_travel_cost_enabled === undefined) ? this.reporttimework.is_travel_cost_enabled = true  : this.reporttimework.is_travel_cost_enabled = item.is_travel_cost_enabled;
    this.reporttimework.user_id = item.user_id;
    this.reporttimework.hours = item.hours;
    this.reporttimework.travel_distance = item.travel_distance;
    this.reporttimework.date = item.date;
    this.reporttimework.comment = (item.comment === undefined) ? '' : item.comment;
    this.reporttimework.reason = (item.reason === undefined) ? '' : item.reason;
    this.selectedindexEditTimer = index;
    this.istimereport_enabled = is_enable_timereport;
  }

  // select worker range change
  reportworkerchange(): void {
    this.reporttimework.user_id = undefined;
  }

  // Get the Date week
  getWeekValue(datestring: string): string {
    // tslint:disable-next-line:prefer-const
    let a = new Date(datestring);
    // tslint:disable-next-line:prefer-const
    let days = new Array(7);
    days[0] = 'Sö';
    days[1] = 'Må';
    days[2] = 'Ti';
    days[3] = 'On';
    days[4] = 'To';
    days[5] = 'Fr';
    days[6] = 'Lö';
    return days[a.getDay()];
  }

  // Get the Weeb for Week View
  getWeekValueByWeekview(datestring: string): string {
    // tslint:disable-next-line:prefer-const
    let a = new Date(datestring);
    // tslint:disable-next-line:prefer-const
    let days = new Array(7);
    days[0] = 'Sön';
    days[1] = 'Mån';
    days[2] = 'Tis';
    days[3] = 'Ons';
    days[4] = 'Tor';
    days[5] = 'Fre';
    days[6] = 'Lör';
    return days[a.getDay()];
  }

  // Get the Date
  getDateByDatestring(datestring: string): number {
    // tslint:disable-next-line:prefer-const
    let a = new Date(datestring);
    return a.getUTCDate();
  }

  // Get All Days from Months to Disable
  getDaysInMonth(month, year) {
    // Since no month has fewer than 28 days
    // tslint:disable-next-line:prefer-const
    let date = new Date(year, month, 1);
    // tslint:disable-next-line:prefer-const
    let days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  }

  // Call Month Change Event In Month View
  callOnMonthChangeEvent($event, type: string) {
    if (type === 'Project') {
      this.setDisplayValueMonthAndWeek($event.year, $event.month - 1, 'Project');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate($event.year, $event.month - 1);
      this.startDateMonth = findDate.startDate;
      this.endDateMonth = findDate.endDate;
      this.getTimesheetsbyProjectId(this.projectId, this.startDateMonth, this.endDateMonth);
    } else {
      this.setDisplayValueMonthAndWeek($event.year, $event.month - 1, 'Worker');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate($event.year, $event.month - 1);
      this.startDateMonthWorker = findDate.startDate;
      this.endDateMonthWorker = findDate.endDate;
      this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
    }

  }

  // Call Year Change Event In Month View
  callOnYearChangeEvent($event, type: string) {
    if (type === 'Project') {
      this.setDisplayValueMonthAndWeek($event.year, $event.month - 1, 'Project');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate($event.year, $event.month - 1);
      this.startDateMonth = findDate.startDate;
      this.endDateMonth = findDate.endDate;
      this.getTimesheetsbyProjectId(this.projectId, this.startDateMonth, this.endDateMonth);
    } else {
      this.setDisplayValueMonthAndWeek($event.year, $event.month - 1, 'Worker');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate($event.year, $event.month - 1);
      this.startDateMonthWorker = findDate.startDate;
      this.endDateMonthWorker = findDate.endDate;
      this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
    }
  }

  // Right Arrow for Month View
  onChangeMonthViewRight(type: string): void {
    if (type === 'Project') {
      this.setDisplayValueMonthAndWeek(new Date(this.endDateMonth).getFullYear(), new Date(this.endDateMonth).getMonth() + 1, 'Project');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate(new Date(this.endDateMonth).getFullYear(), new Date(this.endDateMonth).getMonth() + 1);
      this.startDateMonth = findDate.startDate;
      this.endDateMonth = findDate.endDate;
      this.getTimesheetsbyProjectId(this.projectId, this.startDateMonth, this.endDateMonth);
    } else {
      // tslint:disable-next-line:max-line-length
      this.setDisplayValueMonthAndWeek(new Date(this.endDateMonthWorker).getFullYear(), new Date(this.endDateMonthWorker).getMonth() + 1, 'Worker');
      // tslint:disable-next-line:max-line-length
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate(new Date(this.endDateMonthWorker).getFullYear(), new Date(this.endDateMonthWorker).getMonth() + 1);
      this.startDateMonthWorker = findDate.startDate;
      this.endDateMonthWorker = findDate.endDate;
      this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
    }
  }

  // Left Arrow for Month View
  onChangeMonthViewLeft(type: string): void {
    if (type === 'Project') {
      this.setDisplayValueMonthAndWeek(new Date(this.endDateMonth).getFullYear(), new Date(this.endDateMonth).getMonth() - 1, 'Project');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate(new Date(this.endDateMonth).getFullYear(), new Date(this.endDateMonth).getMonth() - 1);
      this.startDateMonth = findDate.startDate;
      this.endDateMonth = findDate.endDate;
      this.getTimesheetsbyProjectId(this.projectId, this.startDateMonth, this.endDateMonth);
    } else {
      // tslint:disable-next-line:max-line-length
      this.setDisplayValueMonthAndWeek(new Date(this.endDateMonthWorker).getFullYear(), new Date(this.endDateMonthWorker).getMonth() - 1, 'Worker');
      // tslint:disable-next-line:max-line-length
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate(new Date(this.endDateMonthWorker).getFullYear(), new Date(this.endDateMonthWorker).getMonth() - 1);
      this.startDateMonthWorker = findDate.startDate;
      this.endDateMonthWorker = findDate.endDate;
      this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
    }
  }

  // Call On Select Method for Week View
  callOnSelectForWeek(): void {
    // tslint:disable-next-line:prefer-const
    let findweekDate = this.getStartDateAndEndDateForWeek(this.weekViewDatePicker.toLocaleDateString());
    this.startDateWeek = findweekDate.startDate;
    this.endDateWeek = findweekDate.endDate;
    this.setDisplayValueForWeek('Project');
    this.getTimesheetsbyProjectId(this.projectId, this.startDateWeek, this.endDateWeek);
  }


  // Right Arrow for Month View
  onChangeWeekViewRight(type: string): void {
    if (type === 'Project') {
      // tslint:disable-next-line:prefer-const
      let findnewdate = new Date(this.endDateWeek);
      findnewdate.setDate(findnewdate.getDate() + 2);
      // tslint:disable-next-line:prefer-const
      let findweekDate = this.getStartDateAndEndDateForWeek(findnewdate.toLocaleDateString());
      this.startDateWeek = findweekDate.startDate;
      this.endDateWeek = findweekDate.endDate;
      this.setDisplayValueForWeek('Project');
      this.getTimesheetsbyProjectId(this.projectId, this.startDateWeek, this.endDateWeek);
    } else {
      // tslint:disable-next-line:prefer-const
      let findnewdate = new Date(this.endDateWeekWorker);
      findnewdate.setDate(findnewdate.getDate() + 2);
      // tslint:disable-next-line:prefer-const
      let findweekDate = this.getStartDateAndEndDateForWeek(findnewdate.toLocaleDateString());
      this.startDateWeekWorker = findweekDate.startDate;
      this.endDateWeekWorker = findweekDate.endDate;
      this.setDisplayValueForWeek('Worker');
      this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateWeekWorker, this.endDateWeekWorker);
    }
  }
  // Left Arrow for Week View
  onChangeWeekViewLeft(type: string): void {
    if (type === 'Project') {
      // tslint:disable-next-line:prefer-const
      let findnewdate = new Date(this.startDateWeek);
      findnewdate.setDate(findnewdate.getDate() - 3);
      // tslint:disable-next-line:prefer-const
      let findweekDate = this.getStartDateAndEndDateForWeek(findnewdate.toLocaleDateString());
      this.startDateWeek = findweekDate.startDate;
      this.endDateWeek = findweekDate.endDate;
      this.setDisplayValueForWeek('Project');
      this.getTimesheetsbyProjectId(this.projectId, this.startDateWeek, this.endDateWeek);
    } else {
      // tslint:disable-next-line:prefer-const
      let findnewdate = new Date(this.startDateWeekWorker);
      findnewdate.setDate(findnewdate.getDate() - 3);
      // tslint:disable-next-line:prefer-const
      let findweekDate = this.getStartDateAndEndDateForWeek(findnewdate.toLocaleDateString());
      this.startDateWeekWorker = findweekDate.startDate;
      this.endDateWeekWorker = findweekDate.endDate;
      this.setDisplayValueForWeek('Worker');
      this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateWeekWorker, this.endDateWeekWorker);
    }
  }

  // Call worker View
  callOnSelectForWorker(): void {
    // tslint:disable-next-line:prefer-const
    let findweekDate = this.getStartDateAndEndDateForWeek(this.workerWeekViewDatePicker.toLocaleDateString());
    this.startDateWeekWorker = findweekDate.startDate;
    this.endDateWeekWorker = findweekDate.endDate;
    this.setDisplayValueForWeek('Worker');
    this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateWeekWorker, this.endDateWeekWorker);
  }


  // Get the Start Date and End Date Object By Passing Year and Month
  getStartDateAndEndDate(year: number, month: number): any {
    // GET THE FIRST AND LAST DATE OF THE MONTH.
    // tslint:disable-next-line:prefer-const
    let firstDay = new Date(year, month, 1);
    // tslint:disable-next-line:prefer-const
    let lastDay = new Date(year, month + 1, 0);

    // tslint:disable-next-line:prefer-const
    let mmfirst = (firstDay.getMonth() + 1 < 10) ? '0' + (firstDay.getMonth() + 1) : (firstDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddfirst = (firstDay.getDate() < 10) ? '0' + firstDay.getDate() : firstDay.getDate();

    // tslint:disable-next-line:prefer-const
    let mmlast = (lastDay.getMonth() + 1 < 10) ? '0' + (lastDay.getMonth() + 1) : (lastDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddlast = (lastDay.getDate() < 10) ? '0' + lastDay.getDate() : lastDay.getDate();

    // tslint:disable-next-line:max-line-length
    // this.startDateMonth = firstDay.getFullYear() + '-' + mmfirst + '-' + ddfirst;
    // this.endDateMonth = lastDay.getFullYear() + '-' + mmlast + '-' + ddlast;

    return {
      startDate: firstDay.getFullYear() + '-' + mmfirst + '-' + ddfirst,
      endDate: lastDay.getFullYear() + '-' + mmlast + '-' + ddlast
    };

  }

  // Get the StartDate and EndDate For Week
  getStartDateAndEndDateForWeek(date: string): any {
    // tslint:disable-next-line:prefer-const
    let curr = this.momentDateFormat(date, 'MM/DD/YYYY'); // new Date(date); // get current date
    // tslint:disable-next-line:prefer-const
    let currlst = this.momentDateFormat(date, 'MM/DD/YYYY'); // new Date(date); // get current date
    // tslint:disable-next-line:prefer-const
    let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    // tslint:disable-next-line:prefer-const
    let last = first + 6; // last day is the first day + 6

    // tslint:disable-next-line:prefer-const
    let firstDay = new Date(curr.setDate(first));
    // tslint:disable-next-line:prefer-const
    let lastDay = new Date(currlst.setDate(last));

    // tslint:disable-next-line:prefer-const
    let mmfirst = (firstDay.getMonth() + 1 < 10) ? '0' + (firstDay.getMonth() + 1) : (firstDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddfirst = (firstDay.getDate() < 10) ? '0' + firstDay.getDate() : firstDay.getDate();

    // tslint:disable-next-line:prefer-const
    let mmlast = (lastDay.getMonth() + 1 < 10) ? '0' + (lastDay.getMonth() + 1) : (lastDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddlast = (lastDay.getDate() < 10) ? '0' + lastDay.getDate() : lastDay.getDate();

    return {
      startDate: this.findNextDayByPassingDate(firstDay.getFullYear() + '-' + mmfirst + '-' + ddfirst),
      endDate: this.findNextDayByPassingDate(lastDay.getFullYear() + '-' + mmlast + '-' + ddlast)
    };
  }

  momentDateFormat(date, dateformat): Date {
    return moment(date, dateformat).toDate();
  }

  // find Next from passing Date
  findNextDayByPassingDate(date) {
    // tslint:disable-next-line:prefer-const
    let findate = moment(date).add(1, 'days');
    return findate.format('YYYY-MM-DD');
  }

  // find day
  findFirstDayRange(date) {
    // tslint:disable-next-line:prefer-const
    let findate = moment(date);
    return findate.format('YYYY-MM-DD');
  }


  // Set the Display Value for Month
  setDisplayValueMonthAndWeek(year: number, month: number, type: string) {
    if (month === 12) {
      month = 0;
      year = year + 1;
    }
    if (month === -1) {
      month = 11;
      year = year - 1;
    }

    const monthNames = ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni',
    'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'];
    if (type === 'Project') {
      this.monthviewDisplayDate = monthNames[month] + ', ' + year;
    } else if (type === 'Report') {
      this.reportDisplayViewDate = monthNames[month] + ', ' + year;
    } else {
      this.workerMonthviewDisplayDate = monthNames[month] + ', ' + year;
    }
  }

  // Set the  display Value for Week View
  setDisplayValueForWeek(type: string) {
    const monthNames = ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni',
    'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'];
    if (type === 'Project') {
      // tslint:disable-next-line:max-line-length
      this.weekviewDisplayDate = monthNames[new Date(this.startDateWeek).getMonth()] + ' ' + new Date(this.startDateWeek).getDate() + '-' + new Date(this.endDateWeek).getDate() + ', ' + new Date(this.endDateWeek).getFullYear();

    } else if (type === 'Report') {
      // tslint:disable-next-line:max-line-length
      this.reportDisplayViewDate = monthNames[new Date(this.reportstartDate).getMonth()] + ' ' + new Date(this.reportstartDate).getDate() + '-' + new Date(this.reportendDate).getDate() + ', ' + new Date(this.reportendDate).getFullYear();
    } else {
      // tslint:disable-next-line:max-line-length
      this.workerWeekviewDisplayDate = monthNames[new Date(this.startDateWeekWorker).getMonth()] + ' ' + new Date(this.startDateWeekWorker).getDate() + '-' + new Date(this.endDateWeekWorker).getDate() + ', ' + new Date(this.endDateWeekWorker).getFullYear();

    }
  }

  // Clear Add New Project Form
  clearAddProjectForm(): void {
    this.addprojectform.resetForm();
    // this.addprojectform.form.get('newprojectsworker_id').setValue(undefined);
    this.addprojectform.form.get('service_category_id').setValue(undefined);
    this.addprojectform.form.get('sub_category_position').setValue(undefined);
  }

  filterWorkerMultiple(event) {
    // tslint:disable-next-line:prefer-const
    let query = event.query;
    this.projectssuggestionworker = this.filterWorkers(query, this.workerlistAll);
  }

  filterWorkers(query, workers: any[]): any[] {
    // tslint:disable-next-line:prefer-const
    let filtered: Array<any> = [];
    for (let i = 0; i < workers.length; i++) {
      // tslint:disable-next-line:prefer-const
      let worker = workers[i];
      if (worker.worker_name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        if (worker.worker_status_code === 0) {
          filtered.push(worker);
        }
      }
    }
    return filtered;
  }

  // OnchangeCategory
  onChangeCategory(value) {
    this.subserviceCategories = [];
    if (this.newprojects.service_category_id != null || this.newprojects.service_category_id !== undefined) {
      this.subserviceCategories = this.sellerService.getSubCategoryType(this.newprojects.service_category_id.toString());
    }
  }


  // Add New Project
  addNewProjects(model: any, isValid: boolean): void {
    this.isAddreesInvalid = false;
    if (!isValid) {
      return;
    }

    if (this.newprojects.lon == null || this.newprojects.lat == null) {
      this.isAddreesInvalid = true;
      return;
    }

    this.newprojects.seller_id = this.currentSellerId;
    // tslint:disable-next-line:prefer-const
    let workerids: Array<any> = [];
    if (this.newprojectsworker_id !== null) {
      workerids = this.newprojectsworker_id.map(function (item) {
        return item.worker_id;
      });
    }
    this.newprojects.worker_ids = workerids;
    this.newprojects.buyer_invitation_link = environment.buyerendlink + '/buyer/join/project';
    this.loaderActivate = true;
    this.sellerService.addNewProjectBySeller(this.newprojects).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
       // this.agreedProjects.push(res);
        this.addprojectclosebtn.nativeElement.click();

      }
    }, err => {
      console.log(err);
    });
  }

  loadAddressComponent() {

    if (this.searchElementRef) {
      // load Places Autocomplete
      this.mapsAPILoader.load().then(() => {
        // tslint:disable-next-line:prefer-const
        let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
          types: ['address'], componentRestrictions: { country: 'SE' }
        });

        autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            // get the place result
            // tslint:disable-next-line:prefer-const
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();

            // verify result
            if (place.geometry === undefined || place.geometry === null) {
              this.isAddreesInvalid = true;
              return;
            }

            this.newprojects.project_address = place.formatted_address;
            // set latitude, longitude and zoom
           // this.commonObject.lat = place.geometry.location.lat();
           // this.commonObject.lon = place.geometry.location.lng();
            this.isAddreesInvalid = false;
            // this.zoom = 12;
          });
        });
      });
    }

  }


  // Address validare
  onaddressValidateGoogle() {
    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      // tslint:disable-next-line:prefer-const
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ['address'], componentRestrictions: { country: 'SE' }
      });
      // this.commonObject.lat = null;
      // this.commonObject.lon = null;
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          // tslint:disable-next-line:prefer-const
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            this.isAddreesInvalid = true;
            return;
          }

          this.newprojects.project_address = place.formatted_address;
          // set latitude, longitude and zoom
         this.newprojects.lat = place.geometry.location.lat();
          this.newprojects.lon = place.geometry.location.lng();
          this.isAddreesInvalid = false;
          // this.zoom = 12;
          return;
        });
      });
    });
  }

  // Select Change Method call in Report Modal
  callReportModalSelectionChange(): void {
    if (this.reportselectedtype === 1) {
      // tslint:disable-next-line:max-line-length
      // tslint:disable-next-line:prefer-const
      let findreportDate = this.getStartDateAndEndDate(this.reportEndDatePicker.getFullYear(), this.reportEndDatePicker.getMonth() - 1);
      this.reportstartDate = findreportDate.startDate;
      this.reportendDate = findreportDate.endDate;
      this.isSelectedReportPeriod = 'Month';
      this.setDisplayValueMonthAndWeek(new Date().getFullYear(), new Date().getMonth(), 'Report');

    } else if (this.reportselectedtype === 2) {
      // tslint:disable-next-line:prefer-const
      let findnewdate = new Date();
      findnewdate.setDate(findnewdate.getDate() - 4);
      // tslint:disable-next-line:prefer-const
      let findworkerweekDate = this.getStartDateAndEndDateForWeek(findnewdate.toLocaleDateString());
      this.reportstartDate = findworkerweekDate.startDate;
      this.reportendDate = findworkerweekDate.endDate;
      this.isSelectedReportPeriod = 'Week';
      this.setDisplayValueForWeek('Report');
    } else if (this.reportselectedtype === 3) {
      if (this.isSelectedTimesheetView === 'Month' || this.isSelectedTimesheetWorkerView === 'Month') {
        // tslint:disable-next-line:max-line-length
        // tslint:disable-next-line:prefer-const
        let findreportDate = this.getStartDateAndEndDate(new Date().getFullYear(), new Date().getMonth());
        this.reportstartDate = findreportDate.startDate;
        this.reportendDate = findreportDate.endDate;
        this.isSelectedReportPeriod = 'Month';
        this.setDisplayValueMonthAndWeek(new Date().getFullYear(), new Date().getMonth(), 'Report');
        this.reportStartDatePicker = new Date(this.reportstartDate);
        this.reportEndDatePicker = new Date(this.reportendDate);
      } else {
        // tslint:disable-next-line:prefer-const
        let findworkerweekDate = this.getStartDateAndEndDateForWeek(new Date().toLocaleDateString());
        this.reportstartDate = findworkerweekDate.startDate;
        this.reportendDate = findworkerweekDate.endDate;
        this.isSelectedReportPeriod = 'Week';
        this.setDisplayValueForWeek('Report');
        this.reportStartDatePicker = new Date(this.reportstartDate);
        this.reportEndDatePicker = new Date(this.reportendDate);
      }

    }

  }

  // Generate Pdf using Pdf Make
  callgeneratePdf(): void {
    // HERE Date Validations
    this.reporterrormessage = '';
    if (this.reportselectedtype === 3) {
      this.isSelectedReportPeriod = 'SelectRange';
      this.reportstartDate = this.findFirstDayRange(this.reportStartDatePicker);
      this.reportendDate = this.findFirstDayRange(this.reportEndDatePicker);
      this.reportDisplayViewDate =  this.reportstartDate + ' - ' +  this.reportendDate;
      // numberdiff = this.getNumberOfDaysDifferent(this.reportStartDatePicker, this.reportEndDatePicker);
      // if (numberdiff === 6) {
      //   // tslint:disable-next-line:prefer-const
      //   let findworkerweekDate = this.getStartDateAndEndDateForWeek(this.reportEndDatePicker.toLocaleDateString());
      //   this.reportstartDate = findworkerweekDate.startDate;
      //   this.reportendDate = findworkerweekDate.endDate;
      //   this.isSelectedReportPeriod = 'Week';
      //   this.setDisplayValueForWeek('Report');
      // } else {
      //   if (numberdiff === 30 || numberdiff === 29 || numberdiff === 28 || numberdiff === 27) {
      //     // tslint:disable-next-line:prefer-const
      //     let findreportDate = this.getStartDateAndEndDate(this.reportEndDatePicker.getFullYear(), this.reportEndDatePicker.getMonth());
      //     this.reportstartDate = findreportDate.startDate;
      //     this.reportendDate = findreportDate.endDate;
      //     this.isSelectedReportPeriod = 'Month';
      //     this.setDisplayValueMonthAndWeek(this.reportEndDatePicker.getFullYear(), this.reportEndDatePicker.getMonth(), 'Report');

      //   } else {
      //     this.reporterrormessage = 'Please select Month or Week range';
      //     return;
      //   }
      // }
    }


    if (this.isManageProject) {
      this.loaderActivate = true;
      // Call workers by Projects
      this.sellerService.getshowtimesheetsByProject(this.projectId, this.reportstartDate, this.reportendDate).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        if (res != null) {
          if (this.isSelectedReportPeriod === 'Month' || this.isSelectedReportPeriod === 'SelectRange') {
            this.converttoPdfByMonthandProject(res, this.reportDisplayViewDate,
              this.agreedProjects[this.isActiveIndex].project_name);
          } else {
            this.converttoPdfByWeekandProject(res, this.reportDisplayViewDate,
              this.agreedProjects[this.isActiveIndex].project_name);
          }
        }
      }, err => {
        console.log(err);
      });

    } else {
      // userid, startdate, enddate
      this.loaderActivate = true;
      // Call workers by Projects
      this.sellerService.getshowtimesheetsByUserId(this.workeruserid, this.reportstartDate, this.reportendDate).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        if (res != null) {
          // this.timesheetsByworkerId
          if (this.isSelectedReportPeriod === 'Month' || this.isSelectedReportPeriod === 'SelectRange') {
            this.converttoPdfByMonthandProject(res, this.reportDisplayViewDate,
              this.workerInformation.worker_name);
          } else {
            this.converttoPdfByWeekandProject(res, this.reportDisplayViewDate,
              this.workerInformation.worker_name);
          }
        }
      }, err => {
        console.log(err);
      });
    }

  }


  // Generate the PDF Download Option
  callgenerateExcel(): void {

     // HERE Date Validations
     this.reporterrormessage = '';
     if (this.reportselectedtype === 3) {
      this.reportstartDate = this.findFirstDayRange(this.reportStartDatePicker);
      this.reportendDate = this.findFirstDayRange(this.reportEndDatePicker);

      //  let numberdiff = 0;
      //  numberdiff = this.getNumberOfDaysDifferent(this.reportStartDatePicker, this.reportEndDatePicker);
      //  if (numberdiff === 6) {
      //    // tslint:disable-next-line:prefer-const
      //    let findworkerweekDate = this.getStartDateAndEndDateForWeek(this.reportEndDatePicker.toLocaleDateString());
      //    this.reportstartDate = findworkerweekDate.startDate;
      //    this.reportendDate = findworkerweekDate.endDate;
      //    this.isSelectedReportPeriod = 'Week';
      //    this.setDisplayValueForWeek('Report');
      //  } else {
      //    if (numberdiff === 30 || numberdiff === 29 || numberdiff === 28 || numberdiff === 27) {
      //      // tslint:disable-next-line:prefer-const
      //      let findreportDate = this.getStartDateAndEndDate(this.reportEndDatePicker.getFullYear(), this.reportEndDatePicker.getMonth());
      //      this.reportstartDate = findreportDate.startDate;
      //      this.reportendDate = findreportDate.endDate;
      //      this.isSelectedReportPeriod = 'Month';
      //      this.setDisplayValueMonthAndWeek(this.reportEndDatePicker.getFullYear(), this.reportEndDatePicker.getMonth(), 'Report');

      //    } else {
      //      this.reporterrormessage = 'Välj tidsperiod';
      //    //  this.reporterrormessage = 'Please select Month or Week range';
      //    this.reportstartDate = this.findFirstDayRange(this.reportStartDatePicker);
      //    this.reportendDate = this.findFirstDayRange(this.reportEndDatePicker);
      //     // return;
      //    }
      //  }
     }

     if (this.isManageProject) {
       this.loaderActivate = true;
       // Call workers by Projects
       this.sellerService.getshowtimesheetsByProject(this.projectId, this.reportstartDate, this.reportendDate).finally(() => {
         this.loaderActivate = false;
       }).subscribe(res => {
         if (res != null) {
           if (this.isSelectedReportPeriod === 'Month') {
            this.convertToExcelByMonthandProject(res, this.reportDisplayViewDate,
              this.agreedProjects[this.isActiveIndex].project_name);
           } else {
            this.convertToExcelByMonthandProject(res, this.reportDisplayViewDate,
              this.agreedProjects[this.isActiveIndex].project_name);
           }
         }
       }, err => {
         console.log(err);
       });
     } else {
       // userid, startdate, enddate
       this.loaderActivate = true;
       // Call workers by Projects
       this.sellerService.getshowtimesheetsByUserId(this.workeruserid, this.reportstartDate, this.reportendDate).finally(() => {
         this.loaderActivate = false;
       }).subscribe(res => {
         if (res != null) {
           // this.timesheetsByworkerId
           if (this.isSelectedReportPeriod === 'Month') {
             this.convertToExcelByIsManageandProject(res, this.reportDisplayViewDate,
               this.workerInformation.worker_name);
           } else {
             this.convertToExcelByIsManageandProject(res, this.reportDisplayViewDate,
               this.workerInformation.worker_name);
           }
         }
       }, err => {
         console.log(err);
       });
     }

  }


  // Count Number Of days Different between two dates
  getNumberOfDaysDifferent(startdate, enddate): number {
    // tslint:disable-next-line:prefer-const
    let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    // tslint:disable-next-line:prefer-const
    let firstDate = new Date(startdate);
    // tslint:disable-next-line:prefer-const
    let secondDate = new Date(enddate);

    return Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
  }

  // convert Excel By Month
  convertToExcelByMonthandProject(dbObject, displaydate, displayheading) {
    // tslint:disable-next-line:prefer-const
    let data = [];
    if (dbObject != null) {
      data.push({
        Date: 'Dag',
        Project: 'Projekt',
        Worker: 'Arbetare',
        Reportedtime: 'Rapporterad tid',
        Locationrequired: 'Rapportering från projektplats krävs',
        Correctlocation: 'Korrekt plats vid rapportering',
        Wronglocationreason: 'Anledning för fel plats',
        Workdescription: 'Arbetsbeskrivning',
        Travelcost: 'Resekostnad',
        Veichletype: 'Fordon',
        Traveldistance: 'Distans (km)'
      });
      dbObject.users_time_sheets_as_dict.forEach((item, index) => {
        item.date_hours_dict.forEach((itemsub, indexsub) => {
          data.push({
            Date: itemsub.date,
            Project: displayheading,
            Worker: item.first_name,
            Reportedtime: itemsub.hours,
            Locationrequired: (item.is_location_required) ? 'Ja' : 'N/A',
            Correctlocation: (item.is_location_required && itemsub.reason === null) ? 'Nej' : 'N/A',
            Wronglocationreason: (itemsub.reason) ? itemsub.reason : '',
            Workdescription: (itemsub.comment) ? itemsub.comment : '',
            Travelcost: (itemsub.is_travel_cost_enabled) ? 'Ja' : 'N/A',
            Veichletype: (itemsub.travel_type) ? 'Privat' : 'Företag',
            Traveldistance: itemsub.travel_distance
          });
        });

      });
    }
    this.closeExcelDownload.nativeElement.click();
    return new Angular5Csv(data, 'reportcsv');
  }

  convertToExcelByIsManageandProject(dbObject, displaydate, displayheading) {
    // tslint:disable-next-line:prefer-const
    let data = [];
    if (dbObject != null) {
      data.push({
        Date: 'Dag',
        Project: 'Projekt',
        Worker: 'Arbetare',
        Reportedtime: 'Rapporterad tid',
        Locationrequired: 'Rapportering från projektplats krävs',
        Correctlocation: 'Korrekt plats vid rapportering',
        Wronglocationreason: 'Anledning för fel plats',
        Workdescription: 'Arbetsbeskrivning',
        Travelcost: 'Resekostnad',
        Veichletype: 'Fordon',
        Traveldistance: 'Distans (km)'
      });
      dbObject.projects_time_sheets_as_dict.forEach((item, index) => {
        item.date_hours_dict.forEach((itemsub, indexsub) => {
          data.push({
            Date: itemsub.date,
            Project: item.project_name,
            Worker: this.workerInformation.worker_name,
            Reportedtime: itemsub.hours,
            Locationrequired: (item.is_location_required) ? 'Ja' : 'N/A',
            Correctlocation: (item.is_location_required && itemsub.reason === null) ? 'Nej' : 'N/A',
            Wronglocationreason: (itemsub.reason) ? itemsub.reason : '',
            Workdescription: (itemsub.comment) ? itemsub.comment : '',
            Travelcost: (itemsub.is_travel_cost_enabled) ? 'Ja' : 'N/A',
            Veichletype: (itemsub.travel_type) ? 'Privat' : 'Företag',
            Traveldistance: itemsub.travel_distance
          });
        });

      });
    }

    this.closeExcelDownload.nativeElement.click();
    return new Angular5Csv(data, 'reportcsv');
  }

  converttoPdfByMonthandProject(dbObject, displaydate, displayheading) {
    // tslint:disable-next-line:prefer-const
    let dd = {
      content: [
        {
          text: 'YOSSO', alignment: 'center',
          style: 'header'
        },
        { text: 'Tidsrapport', alignment: 'center', style: 'subheader', margin: [0, 0, 0, 10] },
        {
          text: displayheading, // this.agreedProjects[this.isActiveIndex].project_name,
          style: 'subheader'
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*', '*'],
            body: [
              [{ text: (this.isSelectedReportPeriod === 'SelectRange') ? 'Tidsperiod' : 'Månad', border: [false, false, false, true] },
              { text: displaydate, border: [false, false, false, true] }
              ]
            ]
          }
        },
        {
          text: '\n'
        },
        {
          style: 'tableExample',
          table: {
            widths: [120, '*', 120, '*'],
            heights: [50],
            body: [
              // tslint:disable-next-line:max-line-length
              [{
                text: (this.isManageProject) ? dbObject.no_of_workers + '\nAntal arbetare' : dbObject.no_of_projects + '\nAntal projekt',
                style: 'tableitemcontent'
              },
              { text: dbObject.total_hours + '\nAntal timmar', style: 'tableitemcontent' },
              { text: '', style: 'tableitemcontent' },
              { text: '', style: 'tableitemcontent' }]
            ]
          },
          layout: 'noBorders'
        },
        {
          style: 'tableExample',
          table: {
            widths: [120, 70, '*'],
            heights: 70,
            body:
              // tslint:disable-next-line:max-line-length
              (this.isManageProject) ? this.getMonthViewProjectBody(dbObject.users_time_sheets_as_dict) : this.getMonthViewProjectBody(dbObject.projects_time_sheets_as_dict)
          }
        }

      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 0],
          alignment: 'center'
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        tableExample: {
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        },
        tablecontent: {
          bold: false,
          fontSize: 6,
          color: 'black',
          alignment: 'center'
        },
        tablesubcontent: {
          bold: false,
          fontSize: 5,
          color: 'black',
          alignment: 'center'
        },
        tableitemcontent: {
          alignment: 'center'
        }
      }
    };
    pdfMake.createPdf(dd).download();
  }

  converttoPdfByWeekandProject(dbObject, displaydate, displayheading) {
    // tslint:disable-next-line:prefer-const
    let dd = {
      content: [
        {
          text: 'YOSSO', alignment: 'center',
          style: 'header'
        },
        {
          text: 'Tidsrapport', alignment: 'center', style: 'subheader', margin: [0, 0, 0, 10]
        },
        {
          text: displayheading, // this.agreedProjects[this.isActiveIndex].project_name,
          style: 'header'
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*', '*'],
            body: [
              [{ text: 'Vecka', border: [false, false, false, true] },
              { text: displaydate, border: [false, false, false, true] }
              ]
            ]
          }
        },
        {
          text: '\n'
        },
        {
          style: 'tableExample',
          table: {
            widths: [120, '*', 120, '*'],
            heights: [50],
            body: [
              [{
                text: (this.isManageProject) ? dbObject.no_of_workers + '\nAntal arbetare' : dbObject.no_of_projects + '\nAntal projekt',
                style: 'tableitemcontent'
              },
              { text: dbObject.total_hours + '\nAntal timmar', style: 'tableitemcontent' },
              { text: dbObject.last_week_total_hours + '\nFöregående vecka (hrs)', style: 'tableitemcontent' },
              { text: '', style: 'tableitemcontent' }]
            ]
          },
          layout: 'noBorders'
        },
        {
          style: 'tableExample',
          table: {
            widths: [120, 70, '*'],
            heights: 70,
            body:
              // tslint:disable-next-line:max-line-length
              (this.isManageProject) ? this.getWeekViewProjectBody(dbObject.users_time_sheets_as_dict) : this.getWeekViewProjectBody(dbObject.projects_time_sheets_as_dict)
          }
        }

      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        tableExample: {
          margin: [0, 5, 0, 15]
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: 'black'
        },
        tablecontent: {
          bold: false,
          fontSize: 6,
          color: 'black',
          alignment: 'center'
        },
        tablesubcontent: {
          bold: false,
          fontSize: 5,
          color: 'black',
          alignment: 'center'
        },
        tablesubcontentweek: {
          bold: false,
          fontSize: 7,
          color: 'black',
          alignment: 'center'
        },
        tableitemcontent: {
          alignment: 'center'
        },
        tablecontentweek: {
          bold: false,
          fontSize: 9,
          color: 'black',
          alignment: 'center'
        }

      }
    };
    pdfMake.createPdf(dd).download();
  }

  getMonthViewProjectBody(listofWorkers: Array<any>) {
    // tslint:disable-next-line:prefer-const
    let difinereturnarray: Array<any> = [];
    // tslint:disable-next-line:prefer-const
    for (let sub of listofWorkers) {
      // tslint:disable-next-line:prefer-const
      let item = [{
        text: (this.isManageProject) ? sub.first_name + '\n' + this.getDesigncation(sub) : sub.project_name,
        margin: [0, 33, 0, 0]
      },
      { text: sub.total_hours + ' hrs' + '\n' + sub.total_travel_distance + ' km', margin: [0, 33, 0, 0] },
      [
        {
          table: {
            body: this.getInnerBodyForRangeSelectReport(sub.date_hours_dict)
          },
          // layout: 'noBorders'
        }
      ]
      ];
      difinereturnarray.push(item);
    }
    return difinereturnarray;
  }

  getDesigncation(sub) {
    if (sub.designation != null && sub.designation === 'Project Lead') {
      return 'Projektledning';
    } else {
      if (sub.worker_type_name === 'Worker') {
        return 'Arbetare';
      } else {
        return 'Underleverantör';
      }
    }
  }

  getWeekViewProjectBody(listofWorkers: Array<any>) {
    // tslint:disable-next-line:prefer-const
    let difinereturnarray: Array<any> = [];
    // tslint:disable-next-line:prefer-const
    for (let sub of listofWorkers) {
      // tslint:disable-next-line:prefer-const
      let item = [{ text: (this.isManageProject) ? sub.first_name + '\n' + this.getDesigncation(sub) : sub.project_name,
      margin: [0, 20, 0, 0] },
      { text: sub.total_hours + ' hrs' + '\n' + sub.total_travel_distance + ' km', margin: [0, 20, 0, 0] },
      [
        {
          table: {
            heights: [0, 40],
            widths: ['*', '*', '*', '*', '*', '*', '*'],
            body: this.getInnerBodyForWeeklyReport(sub.date_hours_dict)
          },
          // layout: 'noBorders'
        }
      ]
      ];
      difinereturnarray.push(item);
    }
    return difinereturnarray;
  }


  getInnerBodyForWeeklyReport(reportItem: Array<any>) {
    // tslint:disable-next-line:prefer-const
    let difinereturnarray: Array<any> = [];
    if (reportItem.length === 7) {
      difinereturnarray.push([
        {
          border: [false, false, false, false],
          // tslint:disable-next-line:max-line-length
          text: this.getWeekValueByWeekview(reportItem[0].date) + ' ' + this.getDateByDatestring(reportItem[0].date), style: 'tablesubcontentweek'
        },
        {
          border: [false, false, false, false],
          // tslint:disable-next-line:max-line-length
          text: this.getWeekValueByWeekview(reportItem[1].date) + ' ' + this.getDateByDatestring(reportItem[1].date), style: 'tablesubcontentweek'
        },
        {
          border: [false, false, false, false],
          // tslint:disable-next-line:max-line-length
          text: this.getWeekValueByWeekview(reportItem[2].date) + ' ' + this.getDateByDatestring(reportItem[2].date), style: 'tablesubcontentweek'
        },
        {
          border: [false, false, false, false],
          // tslint:disable-next-line:max-line-length
          text: this.getWeekValueByWeekview(reportItem[3].date) + ' ' + this.getDateByDatestring(reportItem[3].date), style: 'tablesubcontentweek'
        },
        {
          border: [false, false, false, false],
          // tslint:disable-next-line:max-line-length
          text: this.getWeekValueByWeekview(reportItem[4].date) + ' ' + this.getDateByDatestring(reportItem[4].date), style: 'tablesubcontentweek'
        },
        {
          border: [false, false, false, false],
          // tslint:disable-next-line:max-line-length
          text: this.getWeekValueByWeekview(reportItem[5].date) + ' ' + this.getDateByDatestring(reportItem[5].date), style: 'tablesubcontentweek'
        },
        {
          border: [false, false, false, false],
          // tslint:disable-next-line:max-line-length
          text: this.getWeekValueByWeekview(reportItem[6].date) + ' ' + this.getDateByDatestring(reportItem[6].date), style: 'tablesubcontentweek'
        }
      ],
        [
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[0].hours, margin: [0, 15, 0, 0], style: 'tablecontentweek'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[1].hours, margin: [0, 15, 0, 0], style: 'tablecontentweek'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[2].hours, margin: [0, 15, 0, 0], style: 'tablecontentweek'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[3].hours, margin: [0, 15, 0, 0], style: 'tablecontentweek'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[4].hours, margin: [0, 15, 0, 0], style: 'tablecontentweek'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[5].hours, margin: [0, 15, 0, 0], style: 'tablecontentweek'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[6].hours, margin: [0, 15, 0, 0], style: 'tablecontentweek'
          }
        ]);
    }

    return difinereturnarray;
  }

  getInnerBosyForMonthlyReport(reportItem: Array<any>) {
    // tslint:disable-next-line:prefer-const
    let difinereturnarray: Array<any> = [];

    // tslint:disable-next-line:prefer-const
    let quotient = Math.floor(reportItem.length / 10);
    // tslint:disable-next-line:prefer-const
    let remainder = reportItem.length % 10;

    if (quotient > 0) {
      if (quotient === 1) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[0].date) + ' ' + this.getWeekValue(reportItem[0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[1].date) + ' ' + this.getWeekValue(reportItem[1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[2].date) + ' ' + this.getWeekValue(reportItem[2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[3].date) + ' ' + this.getWeekValue(reportItem[3].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[4].date) + ' ' + this.getWeekValue(reportItem[4].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[5].date) + ' ' + this.getWeekValue(reportItem[5].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[6].date) + ' ' + this.getWeekValue(reportItem[6].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[7].date) + ' ' + this.getWeekValue(reportItem[7].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[8].date) + ' ' + this.getWeekValue(reportItem[8].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[9].date) + ' ' + this.getWeekValue(reportItem[9].date), style: 'tablesubcontent'
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[2].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[3].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[4].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[5].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[6].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[7].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[8].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[9].hours, style: 'tablecontent'
            }
          ]);
      }

      if (quotient === 2) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[0].date) + ' ' + this.getWeekValue(reportItem[0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[1].date) + ' ' + this.getWeekValue(reportItem[1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[2].date) + ' ' + this.getWeekValue(reportItem[2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[3].date) + ' ' + this.getWeekValue(reportItem[3].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[4].date) + ' ' + this.getWeekValue(reportItem[4].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[5].date) + ' ' + this.getWeekValue(reportItem[5].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[6].date) + ' ' + this.getWeekValue(reportItem[6].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[7].date) + ' ' + this.getWeekValue(reportItem[7].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[8].date) + ' ' + this.getWeekValue(reportItem[8].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[9].date) + ' ' + this.getWeekValue(reportItem[9].date), style: 'tablesubcontent'
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[2].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[3].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[4].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[5].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[6].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[7].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[8].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[9].hours, style: 'tablecontent'
            }
          ]);

        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[10].date) + ' ' + this.getWeekValue(reportItem[10].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[11].date) + ' ' + this.getWeekValue(reportItem[11].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[12].date) + ' ' + this.getWeekValue(reportItem[12].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[13].date) + ' ' + this.getWeekValue(reportItem[13].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[14].date) + ' ' + this.getWeekValue(reportItem[14].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[15].date) + ' ' + this.getWeekValue(reportItem[15].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[16].date) + ' ' + this.getWeekValue(reportItem[16].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[17].date) + ' ' + this.getWeekValue(reportItem[17].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[18].date) + ' ' + this.getWeekValue(reportItem[18].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[19].date) + ' ' + this.getWeekValue(reportItem[19].date), style: 'tablesubcontent'
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[10].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[11].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[12].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[13].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[14].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[15].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[16].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[17].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[18].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[19].hours, style: 'tablecontent'
            }
          ]);
      }

      if (quotient === 3) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[0].date) + ' ' + this.getWeekValue(reportItem[0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[1].date) + ' ' + this.getWeekValue(reportItem[1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[2].date) + ' ' + this.getWeekValue(reportItem[2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[3].date) + ' ' + this.getWeekValue(reportItem[3].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[4].date) + ' ' + this.getWeekValue(reportItem[4].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[5].date) + ' ' + this.getWeekValue(reportItem[5].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[6].date) + ' ' + this.getWeekValue(reportItem[6].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[7].date) + ' ' + this.getWeekValue(reportItem[7].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[8].date) + ' ' + this.getWeekValue(reportItem[8].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[9].date) + ' ' + this.getWeekValue(reportItem[9].date), style: 'tablesubcontent'
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[2].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[3].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[4].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[5].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[6].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[7].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[8].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[9].hours, style: 'tablecontent'
            }
          ]);

        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[10].date) + ' ' + this.getWeekValue(reportItem[10].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[11].date) + ' ' + this.getWeekValue(reportItem[11].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[12].date) + ' ' + this.getWeekValue(reportItem[12].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[13].date) + ' ' + this.getWeekValue(reportItem[13].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[14].date) + ' ' + this.getWeekValue(reportItem[14].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[15].date) + ' ' + this.getWeekValue(reportItem[15].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[16].date) + ' ' + this.getWeekValue(reportItem[16].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[17].date) + ' ' + this.getWeekValue(reportItem[17].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[18].date) + ' ' + this.getWeekValue(reportItem[18].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[19].date) + ' ' + this.getWeekValue(reportItem[19].date), style: 'tablesubcontent'
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[10].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[11].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[12].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[13].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[14].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[15].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[16].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[17].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[18].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[19].hours, style: 'tablecontent'
            }
          ]);

        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[20].date) + ' ' + this.getWeekValue(reportItem[20].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[21].date) + ' ' + this.getWeekValue(reportItem[21].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[22].date) + ' ' + this.getWeekValue(reportItem[22].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[23].date) + ' ' + this.getWeekValue(reportItem[23].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[24].date) + ' ' + this.getWeekValue(reportItem[24].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[25].date) + ' ' + this.getWeekValue(reportItem[25].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[26].date) + ' ' + this.getWeekValue(reportItem[26].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[27].date) + ' ' + this.getWeekValue(reportItem[27].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[28].date) + ' ' + this.getWeekValue(reportItem[28].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[29].date) + ' ' + this.getWeekValue(reportItem[29].date), style: 'tablesubcontent'
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[20].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[21].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[22].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[23].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[24].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[25].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[26].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[27].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[28].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[29].hours, style: 'tablecontent'
            }
          ]);
      }
    }

    if (quotient === 3) {
      if (remainder === 1) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[30].date) + ' ' + this.getWeekValue(reportItem[30].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[30].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]);
      }
    }

    if (quotient === 2) {
      if (remainder === 8) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[20].date) + ' ' + this.getWeekValue(reportItem[20].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[21].date) + ' ' + this.getWeekValue(reportItem[22].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[22].date) + ' ' + this.getWeekValue(reportItem[22].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[23].date) + ' ' + this.getWeekValue(reportItem[23].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[24].date) + ' ' + this.getWeekValue(reportItem[24].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[25].date) + ' ' + this.getWeekValue(reportItem[25].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[26].date) + ' ' + this.getWeekValue(reportItem[26].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[27].date) + ' ' + this.getWeekValue(reportItem[27].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[20].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[21].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[22].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[23].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[24].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[25].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[26].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[27].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
      }

      if (remainder === 9) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[20].date) + ' ' + this.getWeekValue(reportItem[20].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[21].date) + ' ' + this.getWeekValue(reportItem[22].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[22].date) + ' ' + this.getWeekValue(reportItem[22].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[23].date) + ' ' + this.getWeekValue(reportItem[23].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[24].date) + ' ' + this.getWeekValue(reportItem[24].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[25].date) + ' ' + this.getWeekValue(reportItem[25].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[26].date) + ' ' + this.getWeekValue(reportItem[26].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[27].date) + ' ' + this.getWeekValue(reportItem[27].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[28].date) + ' ' + this.getWeekValue(reportItem[28].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[20].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: reportItem[21].hours,
            },
            {
              border: [false, false, false, false],
              text: reportItem[22].hours,
            },
            {
              border: [false, false, false, false],
              text: reportItem[23].hours,
            },
            {
              border: [false, false, false, false],
              text: reportItem[24].hours,
            },
            {
              border: [false, false, false, false],
              text: reportItem[25].hours,
            },
            {
              border: [false, false, false, false],
              text: reportItem[26].hours,
            },
            {
              border: [false, false, false, false],
              text: reportItem[27].hours,
            },
            {
              border: [false, false, false, false],
              text: reportItem[28].hours,
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]);
      }
    }


    return difinereturnarray;
  }

  getInnerBodyForRangeSelectReport(reportItem: Array<any>) {
    // tslint:disable-next-line:prefer-const
    let difinereturnarray: Array<any> = [];

    // tslint:disable-next-line:prefer-const
    let quotient = Math.floor(reportItem.length / 10);
    // tslint:disable-next-line:prefer-const
    let remainder = reportItem.length % 10;
    // tslint:disable-next-line:prefer-const
    let marginalindex = 0;
    for (let index = 0; index < quotient; index++) {
      difinereturnarray.push([
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
            + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
        },
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 1].date)
            + ' ' + this.getWeekValue(reportItem[marginalindex + 1].date), style: 'tablesubcontent'
        },
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 2].date) +
            ' ' + this.getWeekValue(reportItem[marginalindex + 2].date), style: 'tablesubcontent'
        },
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 3].date)
            + ' ' + this.getWeekValue(reportItem[marginalindex + 3].date), style: 'tablesubcontent'
        },
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 4].date)
            + ' ' + this.getWeekValue(reportItem[marginalindex + 4].date), style: 'tablesubcontent'
        },
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 5].date) + ' '
            + this.getWeekValue(reportItem[marginalindex + 5].date), style: 'tablesubcontent'
        },
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 6].date)
            + ' ' + this.getWeekValue(reportItem[marginalindex + 6].date), style: 'tablesubcontent'
        },
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 7].date)
            + ' ' + this.getWeekValue(reportItem[marginalindex + 7].date), style: 'tablesubcontent'
        },
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 8].date)
            + ' ' + this.getWeekValue(reportItem[marginalindex + 8].date), style: 'tablesubcontent'
        },
        {
          border: [false, false, false, false],
          text: this.getDateByDatestring(reportItem[marginalindex + 9].date) +
            ' ' + this.getWeekValue(reportItem[marginalindex + 9].date), style: 'tablesubcontent'
        }
      ],
        [
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 1].hours, style: 'tablecontent'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 2].hours, style: 'tablecontent'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 3].hours, style: 'tablecontent'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 4].hours, style: 'tablecontent'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 5].hours, style: 'tablecontent'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 6].hours, style: 'tablecontent'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 7].hours, style: 'tablecontent'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 8].hours, style: 'tablecontent'
          },
          {
            border: [true, true, true, true],
            fillColor: '#eeeeee',
            text: reportItem[marginalindex + 9].hours, style: 'tablecontent'
          }
        ]);
        marginalindex = marginalindex + 10;
    }

    if (remainder > 0) {
      if (remainder === 1) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
      }
      if (remainder === 2) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 1].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 1].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
      }
      if (remainder === 3) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 1].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 2].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 2].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
      }
      if (remainder === 4) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 1].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 2].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 3].date) + ' '
              + this.getWeekValue(reportItem[marginalindex + 3].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 2].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 3].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
      }

      if (remainder === 5) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 1].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 2].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 3].date) + ' '
              + this.getWeekValue(reportItem[marginalindex + 3].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 4].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 4].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 2].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 3].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 4].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
      }

      if (remainder === 6) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 1].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 2].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 3].date) + ' '
              + this.getWeekValue(reportItem[marginalindex + 3].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 4].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 4].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 5].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 5].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 2].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 3].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 4].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 5].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
      }

      if (remainder === 7) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 1].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 2].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 3].date) + ' '
              + this.getWeekValue(reportItem[marginalindex + 3].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 4].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 4].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 5].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 5].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 6].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 6].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 2].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 3].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 4].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 5].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 6].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
      }

      if (remainder === 8) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 1].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 2].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 3].date) + ' '
              + this.getWeekValue(reportItem[marginalindex + 3].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 4].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 4].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 5].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 5].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 6].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 6].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 7].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 7].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: '',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 2].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 3].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 4].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 5].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 6].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 7].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
      }

      if (remainder === 9) {
        difinereturnarray.push([
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 0].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 0].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 1].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 1].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 2].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 2].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 3].date) + ' '
              + this.getWeekValue(reportItem[marginalindex + 3].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 4].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 4].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 5].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 5].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 6].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 6].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 7].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 7].date), style: 'tablesubcontent'
          },
          {
            border: [false, false, false, false],
            text: this.getDateByDatestring(reportItem[marginalindex + 8].date)
              + ' ' + this.getWeekValue(reportItem[marginalindex + 8].date), style: 'tablesubcontent',
          },
          {
            border: [false, false, false, false],
            text: '',
          }
        ],
          [
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 0].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 1].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 2].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 3].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 4].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 5].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 6].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 7].hours, style: 'tablecontent'
            },
            {
              border: [true, true, true, true],
              fillColor: '#eeeeee',
              text: reportItem[marginalindex + 8].hours, style: 'tablecontent'
            },
            {
              border: [false, false, false, false],
              text: '',
            }
          ]
        );
    }
  }


    return difinereturnarray;
  }


  /// Add New Project New Concept
  callAddNewInternalProject() {
    this.isaddnewproject = true;
  }

  receiveActivetabMessage($event) {
    if ($event === 'Scope') {
      this.isActiveScope = true;
    } else if ($event === 'Details') {
      this.isActiveDetails = true;
    } else if ($event === 'CustomerInfo') {
      this.isActiveCutomerInfo = true;
    }
    this.isActiveTabName = $event;
  }

  onClickTabSelection(value) {
    if (value === 'Scope' && !this.isActiveScope) {
      return;
    }
    if (value === 'Details' && !this.isActiveDetails) {
      return;
    }

    this.isActiveTabName = value;
  }

  //  Clear the Basic Information
  clearBasicInformation() {
    this.isActiveTabName = 'CustomerInfo';
    this.isActiveScope = false;
    this.isActiveDetails = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/seller/manage-projects/manage-projects.component.ts